import axios from 'axios'
import { apiConfig } from '../config/api'

const chatApi = axios.create({
  baseURL: apiConfig.baseUrl,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  }
})

chatApi.interceptors.request.use((config) => {
  let data = apiConfig.apiKey
  if (data) {
    config.headers.Authorization = 'Bearer ' + data
  }
  config.headers['isNewToken'] = true
  const uuid = sessionStorage.getItem('uuid')
  uuid && (config.headers['x-uuid'] = uuid)
  return config
}, (error) => {
  return Promise.reject(error)
})

// 响应拦截器 -> 错误处理与 401 拦截
chatApi.interceptors.response.use((res) => {
  return res
}, (error) => {
  return Promise.reject(error)
})

function buildMessagesPath(conversationId) {
  return apiConfig.messagesEndpoint
    .replace('{conversationId}', conversationId)
    .replace('{conversation_id}', conversationId)
}

export function getConversationMessages(params) {
  return chatApi({
    url: buildMessagesPath(params.conversationId),
    method: 'GET',
    params: {
      page_num: params.pageNum || 1,
      page_size: params.pageSize || apiConfig.defaultPageSize,
    },
  })
}

export function createConversation(params) {
  return chatApi({
    url: apiConfig.createConversationEndpoint,
    method: 'POST',
    data: {
      agent_id: params.agentId,
      ...(params.fileIds?.length ? { file_ids: params.fileIds } : {}),
      ...(params.thirdUserId ? { third_user_id: params.thirdUserId } : {}),
    },
  })
}

export function sendConversationMessage(params) {
  return chatApi({
    url: apiConfig.conversationsEndpoint,
    method: 'POST',
    data: {
      message: params.message,
      conversation_id: params.conversationId,
      ...(params.agentId ? { agent_id: params.agentId } : {}),
      ...(params.thirdUserId ? { third_user_id: params.thirdUserId } : {}),
    },
  })
}
